module.exports = __webpack_public_path__ + "static/media/img_8.4f2db565.png";